import { UserIdentity } from '../identity/types';

export interface Channel {
  id: string;
  name: string;
  type: 'text' | 'voice';
  position?: number;
  category_id?: string | null;
  customization?: any;
}

class EntityResolver {
  private userCache: Map<string, UserIdentity> = new Map();
  private channelCache: Map<string, Channel> = new Map();
  private serverCache: Map<string, any> = new Map();

  resolveUser(id: string): UserIdentity | undefined {
    return this.userCache.get(id);
  }
  
  resolveChannel(id: string): Channel | undefined {
    return this.channelCache.get(id);
  }
  
  resolveServer(id: string): any | undefined {
    return this.serverCache.get(id);
  }
  
  updateUser(id: string, user: UserIdentity) {
    this.userCache.set(id, user);
  }

  updateChannel(id: string, channel: Channel) {
    this.channelCache.set(id, channel);
  }

  updateServer(id: string, server: any) {
    this.serverCache.set(id, server);
  }
}

export const entityResolver = new EntityResolver();
